/* eslint-disable react-hooks/exhaustive-deps */
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import phoneImg from "../assets/phone.png";
import "../css/ServicesSection.css";

// 🔹 Loan & Lending Specific Features Array
const features = [
  { icon: "⚡", text: "Instant Loan Approval & Quick Disbursal" },
  { icon: "📊", text: "Automated Credit Score & Eligibility Check" },
  { icon: "📄", text: "100% Paperless Digital Loan Application" },
  { icon: "🤝", text: "Micro-Finance & Group Loan Solutions" },
  { icon: "🗓️", text: "Flexible Repayment & Flexible EMI Schedules" },
  { icon: "🔒", text: "Secure Document Verification & E-KYC" },
  { icon: "💬", text: "24/7 AI Loan Assistant & Support" },
  { icon: "🔔", text: "Automated EMI Payment Reminders" },
  { icon: "📱", text: "Live Loan Status Tracking & History" },
  { icon: "🛡️", text: "Transparent Interest Rates & Zero Hidden Fees" },
];

const FeatureList = () => {
  const [index, setIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(4);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) setItemsPerPage(1);
      else if (window.innerWidth < 1024) setItemsPerPage(2);
      else setItemsPerPage(4);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextSlide = () => setIndex((prev) => (prev + itemsPerPage) % features.length);
  const prevSlide = () =>
    setIndex((prev) =>
      prev - itemsPerPage < 0 ? features.length - itemsPerPage : prev - itemsPerPage
    );

  useEffect(() => {
    const interval = setInterval(nextSlide, 6000);
    return () => clearInterval(interval);
  }, [itemsPerPage]);

  const currentFeatures = features.slice(index, index + itemsPerPage);
  if (currentFeatures.length < itemsPerPage) {
    currentFeatures.push(...features.slice(0, itemsPerPage - currentFeatures.length));
  }

  return (
    <div className="sh-container">
      {/* Left Section */}
      <div className="sh-left-panel">
        <div className="sh-next-gen">
          <h2 className="sh-main-title">Next-Gen Features</h2>
          <h3 className="sh-sub-title">Smart Lending Experience</h3>
        </div>

        <AnimatePresence mode="wait">
          <motion.ul
            className="sh-features"
            key={index}
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 40 }}
            transition={{ duration: 0.6 }}
          >
            {currentFeatures.map((feature, i) => (
              <li key={i} className="sh-feature-item">
                <div className="sh-icon-circle">
                  <span className="sh-icon">{feature.icon}</span>
                </div>
                <p className="sh-feature-text">{feature.text}</p>
              </li>
            ))}
          </motion.ul>
        </AnimatePresence>

        <div className="sh-carousel-controls">
          <button className="sh-round-btn" onClick={prevSlide}>
            <FaArrowLeft />
          </button>
          <button className="sh-round-btn" onClick={nextSlide}>
            <FaArrowRight />
          </button>
        </div>

        <div className="sh-dots">
          {Array.from({ length: Math.ceil(features.length / itemsPerPage) }).map(
            (_, i) => (
              <span
                key={i}
                className={`sh-dot ${
                  i === Math.floor(index / itemsPerPage) ? "sh-active" : ""
                }`}
              />
            )
          )}
        </div>
      </div>

      {/* Right Section */}
      <div className="sh-right-panel">
        {/* Image */}
        <img src={phoneImg} alt="phone" className="sh-right-image" />

        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            className="sh-overlay-features"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.6 }}
          >
            {currentFeatures.map((feature, i) => (
              <motion.div
                key={i}
                className="sh-overlay-item"
                whileHover={{
                  scale: 1.07,
                  boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                }}
              >
                <span className="sh-overlay-icon">{feature.icon}</span>
                <span className="sh-overlay-text">{feature.text}</span>
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default FeatureList;